import littlewoods from 'constants/littlewoods';
import verypay from 'constants/verypay';
import { insuranceVoucherMap } from 'constants/promotion-voucher-constants';
import deliveryContent from 'constants/deliveryContent';

type Content = {
  [key: string]: string;
};

export default {
  ...littlewoods,
  ...insuranceVoucherMap,
  ...verypay,
  ...deliveryContent
  } as Content;
